module.exports = __webpack_public_path__ + "static/media/store-off.9463b4d2.svg";